import rawVariables from './rawVariablesHttp';

const getRawVariables = (context) => {
  return new Promise((resolve, reject) => {
    rawVariables.getRawVariables(context)
      .then(data => {
        resolve(data.body);
      }, error => {
        reject(error);
      });
  });
};

const updateRawVariable = (context, rawVariable) => {
  return new Promise((resolve, reject) => {
    rawVariables.updateRawVariable(context, rawVariable)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getRawVariables,
  updateRawVariable
};



// WEBPACK FOOTER //
// ./src/api/rawVariables/index.js